import { LockOutlined, UserOutlined } from "@ant-design/icons";
import { Alert, Button, Card, Form, Input, Typography } from "antd";
import { useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router";

import { useSession } from "../auth/SessionProvider";

interface LoginForm {
  username: string;
  password: string;
}

export function Login() {
  const { state, login } = useSession();
  const navigate = useNavigate();
  const location = useLocation();
  const [error, setError] = useState<string>();
  const [submitting, setSubmitting] = useState(false);
  if (state.status === "authenticated") return <Navigate to="/" replace />;
  const from = (location.state as { from?: string } | null)?.from;

  const submit = async (values: LoginForm) => {
    setSubmitting(true);
    setError(undefined);
    try {
      await login(values.username.trim(), values.password);
      navigate(from && from !== "/login" ? from : "/", { replace: true });
    } catch (caught) {
      setError(caught instanceof Error ? caught.message : "登录失败");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="login-page">
      <Card className="login-card">
        <div className="login-brand">
          <img src="./lmcc-logo.png" alt="LMCC" className="login-logo" />
          <Typography.Title level={3} className="login-title">LMCC 认证管理</Typography.Title>
        </div>
        <Form<LoginForm> layout="vertical" onFinish={submit} requiredMark={false} size="large">
          <Form.Item name="username" label="账号" rules={[{ required: true, message: "请输入账号" }]}>
            <Input prefix={<UserOutlined />} autoComplete="username" maxLength={128} autoFocus />
          </Form.Item>
          <Form.Item name="password" label="密码" rules={[{ required: true, message: "请输入密码" }]}>
            <Input.Password prefix={<LockOutlined />} autoComplete="current-password" />
          </Form.Item>
          {error && <Alert type="error" showIcon message={error} className="login-error" />}
          <Button type="primary" htmlType="submit" block loading={submitting}>
            登录
          </Button>
        </Form>
      </Card>
    </div>
  );
}
